// This is a reducer function that handles the state updates for restaurant list data.
// It takes in the current state and an action object as arguments.

import {
  FETCH_REST_LIST_FAILURE,
  FETCH_REST_LIST_REQUEST,
  FETCH_REST_LIST_RESET,
  FETCH_REST_LIST_SUCCESS,
} from './type';

const initialState = {
  rest: [],
  loading: false,
  error: null,
  more: false,
  search: '',
  sRest: [],
};

export default function restReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REST_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REST_LIST_SUCCESS:
      if (action.payload.search.length) {
        if (action.payload.search === state.search) {
          // Keep nearby list intact; append search page results
          return {
            ...state,
            loading: false,
            sRest: [...state.sRest, ...action.payload.restaurant],
            more: action.payload.hasMore,
            search: action.payload.search,
          };
        }
        // New search query — replace search results only
        return {
          ...state,
          loading: false,
          sRest: [...action.payload.restaurant],
          more: action.payload.hasMore,
          search: action.payload.search,
        };
      }
      return {
        ...state,
        loading: false,
        rest:
          action.payload.page === 1
            ? [...action.payload.restaurant]
            : [...state.rest, ...action.payload.restaurant],
        sRest: [],
        more: action.payload.hasMore,
        search: '',
      };
    case FETCH_REST_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REST_LIST_RESET:
      return { ...initialState };
    default:
      return state;
  }
}
